
import { EnvironmentModel } from './helpers/environment.model';
export const environment: EnvironmentModel = {"production":true,"api_url":"https://backend.sebi.dev/api/","pageEndpoint":"page/","fileEndpoint":"file/","api_key":"IL1WkkO2598Yu6Zn4lpXb","lg_lic":"W674L-7ZA3D-DNWKQ-ZASBA"};
